<template>
  <onboard-wrap>
    <div class="form-area">
      <h1>Start a New Team?</h1>
      <p>Are you sure you want to leave <strong>{{teamName}}</strong> and start your own team?</p>
    </div>
    <div class="btn-wrap">
      <router-link :to="{ name: 'name' }" class="btn btn-lg">Start My Own Team</router-link>
      <p>No, <router-link :to="{ name: 'overview' }">stay with {{teamName}}</router-link></p>
    </div>
  </onboard-wrap>
</template>

<script>
import teamWrap from '@/components/team-wrap/team-wrap'

export default {
  name: 'new-team',
  components: {
    'onboard-wrap': teamWrap
  },
  data () {
    return {}
  },
  computed: {
    teamName: function () {
      return this.$store.state.userData.teamName
    }
  },
  methods: {},
  watch: {},
  beforeMount: function () {
    this.$store.dispatch('getUserDetails')
  }
}
</script>

<style scoped lang="stylus" src="./new-team.styl" >



// WEBPACK FOOTER //
// src/views/start/views/new-team/new-team.vue